module.exports = __webpack_public_path__ + "static/media/6.991efb1b.png";